


import Vue from 'vue'
import { State as UsersState } from '@/store/modules/users'

export default Vue.extend({
  name: 'TwitterAuth',
  mounted() {
    this.$store.dispatch('twitter/fetchTwitterUrl')
  }
})
